import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'

@jsonClass('TriggerConfiguration')
export class TriggerConfiguration {
	@jsonProperty(String)
	get __type(): string {
		return 'TriggerConfiguration'
	}
	set __type(_) {
		/*ignore*/
	}

	@jsonProperty(String)
	moduleId!: string
	@jsonProperty(String)
	boId!: string
	@jsonProperty(String)
	branchNameToUse!: string
	@jsonProperty(Boolean)
	isAutostart: boolean = false
	@jsonProperty(Boolean)
	isActive: boolean = false

	constructor(init?: Partial<TriggerConfiguration>) {
		assignCommonProperties(this, init)
	}

	updateConfig(from: TriggerConfiguration) {
		const hasDbRelevantChanges =
			this.isAutostart != from.isAutostart ||
			this.branchNameToUse != from.branchNameToUse // ignore isActive
		const hasRestartRelevantChanges =
			this.branchNameToUse != from.branchNameToUse ||
			this.isActive != from.isActive // ignore isAutostart
		this.isActive = from.isActive
		this.isAutostart = from.isAutostart
		this.branchNameToUse = from.branchNameToUse

		return { hasDbRelevantChanges, hasRestartRelevantChanges }
	}

	getQualifiedName() {
		return `${this.moduleId}.${this.boId}`
	}
}
